<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收费方案详情-基本信息
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-loading="loading" class="data-statistic">
    <div class="front-line mr" style="margin: 15px 0 30px 0px;">收入统计</div>
    <el-row :gutter="20">
      <el-col :span="11">
        <div class="bg-light radius5 card-item flex column justify-content-space-between" style="height: 120px">
          <div>收入金额</div>
          <div class="text-success font-2x">￥{{ inc_stat.total_payed ? (inc_stat.total_payed).toFixed(2) : 0 }}</div>
        </div>
      </el-col>
      <el-col :span="11">
        <div class="bg-light radius5 card-item flex column justify-content-space-between" style="height: 120px">
          <div>收入笔数</div>
          <div class="text-success font-2x">{{ inc_stat.count }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="front-line mr" style="margin: 30px 0px;">设备统计</div>
    <div class="relative">
      <EquipStatisticPie :stat="equip_stat" style="height: 400px; width: 400px" />
      <div class="absolute">{{ equip_stat.total_count }}</div>
    </div>
  </div>
</template>

<script>
import { schemeStatApi } from "@/api/ei/eiApi";
import EquipStatisticPie from "@/views/ei/components/EquipStatisticPie";

export default {
  name: "DataStatistic",

  components: {
    EquipStatisticPie,
  },

  props: {},

  data() {
    return {
      loading: false,
      schemeid: this.$route.query.schemeid
        ? parseInt(this.$route.query.schemeid)
        : undefined,
      inc_stat: {},
      equip_stat: {},
    };
  },

  computed: {},

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      schemeStatApi({ schemeid: this.schemeid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.inc_stat = Object.assign({}, res.data.inc_stat);
          this.equip_stat = Object.assign({}, res.data.equip_stat);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-item {
  padding: 15px 20px;
}
</style>
<style lang="scss">
.relative {
  position: relative;
}
.absolute {
  position: absolute;
  text-align: center;
  width: 200px;
  font-size: 28px;
  top: calc(35% - 14px);
  left: 100px;
  margin: 0 auto;
  color: rgba(58, 146, 251, 100);
}
</style>
